import React, {h, Component} from 'preact';

var buttonStyle = {
    'height': '56px',
    'margin-top': '16px',
    'border-radius': '8px',
    'box-shadow': '0 4px 8px 0 rgba(12, 0, 51, 0.1)',
    'background-color': '#ffffff',
    'padding': '18px 16px'
};

export default class BuyHomeTypeStep extends Component {

    chooseHomeType(homeType) {
        $.get('update-buyrequest-json', {
            location: this.props.location,
            propertyType: homeType,
            priceRange: this.props.parent.state.lowRange + '-' + this.props.parent.state.highRange
        });
        this.props.parent.setState({homeType: homeType, currentStep: 'BUY_PROCESS'});
    }

    componentDidMount() {
        trackEvent('Flow', 'BuyRequest', 'buyStep2').withGA().withOptimizely();
        trackEvent('Flow', 'BuyRequest', 'buyerLoadedStep3').withGA().withOptimizely();
    }

    render() {
        return <div className="flow-step">
            <div className="flow-step-text hidden-xs">
                <img className ="icon-desktop" src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'} />
                <div>UpNest Partner Agents specialize in the {this.props.parent.state.priceRangeStr} price range.</div>
            </div>

            <div className="flow-step-header-text">
                <strong>What kind of home are you looking to buy in {this.props.city ? this.props.city : this.props.location}?</strong>
            </div>
            <div className="option-div">
                <div id="home-type-div" className="buy-home-type-div">
                    <div className="choice-button buy-home-type-button" onClick={() => this.chooseHomeType('Single Family')}>
                        <img src={global.imageBaseUrl + '/buysell/svg/single-family.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Single Family</span>
                        </div>
                    </div>
                    <div className="choice-button buy-home-type-button" onClick={() => this.chooseHomeType('Condo or Townhouse')}>
                        <img src={global.imageBaseUrl + '/buysell/svg/townhouse.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Condo or Townhouse</span>
                        </div>
                    </div>
                    <div className="choice-button buy-home-type-button" onClick={() => this.chooseHomeType('Investment Property')}>
                        <img src={global.imageBaseUrl + '/buysell/svg/condominium.svg'}/>
                        <div className="button-text" style={{overflow: 'hidden'}}>
                            <span>Investment Property</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className="flow-spacer"/>

            <div className="bottom-banner">
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + '/buysell/svg/top-agents.svg'}/> Top Performing Agents</div>
                    <div className="subtitle subtitle-large">UpNest Partner Agents specialize in the {this.props.parent.state.priceRangeStr} price range.</div>
                </div>
                <div className="status-normal subtitle subtitle-small">
                    UpNest Partner Agents specialize in the {this.props.parent.state.priceRangeStr} price range.
                </div>
            </div>
        </div>;
    }
}
